export default __webpack_public_path__ + "assets/icons/iconReceive.688be5d5.svg";